import { render, staticRenderFns } from "./OnboardingContentsFrame.vue?vue&type=template&id=39dc6a87"
import script from "./OnboardingContentsFrame.vue?vue&type=script&lang=js"
export * from "./OnboardingContentsFrame.vue?vue&type=script&lang=js"
import style0 from "./OnboardingContentsFrame.vue?vue&type=style&index=0&id=39dc6a87&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports